// Reaction Monitor Constants
export const GET_RM_REPORT_REQUEST = 'GET_RM_REPORT_REQUEST';
export const GET_RM_REPORT_SUCCESS = 'GET_RM_REPORT_SUCCESS';
export const GET_RM_REPORT_FAILURE = 'GET_RM_REPORT_FAILURE';

// OD Reading Types
export const READING_TYPE_PRIMARY = 'PrimaryODReadings';
export const READING_TYPE_SECONDARY = 'SecondaryODReadings';
export const READING_TYPE_REACTION = 'ReactionODReadings';
export const READING_TYPE_RBODDATA = 'RBODReadings';

// WB Data Reading Type
export const READING_TYPE_PHOTOCAL_WB = 'PhotocalWBDataReadings';
